import { Box, Grid } from "@mui/material";
import {
	EmailFieldRHF,
	ExtensionNumberRHF,
	PhoneNumberRHF,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface IPADAgreenmentBankManagerFieldsPanel { }
export const PADAgreenmentBankManagerFieldsPanel: FC<
	IPADAgreenmentBankManagerFieldsPanel
> = ({ }) => {
	return (
		<Box>
			<RHookFormTextFieldWithLabel
				id="bankManagerName"
				label="Name"
				testId={`bankManagerName`}
			/>
			{/* <RHookFormTextFieldWithLabel
				id="bankManagerEmail"
				label="Email"
				testId={`bankManagerEmail`}
			/> */}
			<EmailFieldRHF
				id="bankManagerEmail"
				label="Email"
				testId={`bankManagerEmail`}
			// labelPosition={LabelPosition.Top}
			// labelColumns={4}
			// fieldColumns={8}
			// required
			/>
			<Grid
				container
				columnSpacing={0}
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
			>
				<Grid size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}>
					<PhoneNumberRHF
						label="Phone No."
						id="bankManagerPhone"
						testId={`phone`}
					/>
				</Grid>
				<Grid
					size={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}
				></Grid>
				<Grid size={{ xs: 3, sm: 3, md: 3, lg: 3, xl: 3 }}>
					<ExtensionNumberRHF
						label="Ext."
						id="bankManagerExt"
						testId={`ext`}
					/>
				</Grid>
			</Grid>
		</Box>
	);
};
